<template>
  <el-container class="userManagement-box" direction="vertical">
    <el-row>
      <el-form inline>
        <el-form-item label="来源">
          <el-select v-model="form.source" clearable placeholder="请选择">
            <el-option
              v-for="item in userSourceList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用户信息">
          <el-input
            placeholder="用户ID、姓名、手机号、证件号"
            class="input-box"
            clearable
            v-model.trim="form.keyword"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="服务项目">
          <el-select v-model="form.xiangmu" clearable placeholder="请选择">
            <el-option
              v-for="item in xiangmList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="健康值"
          ><el-input-number
            style="width: 100px"
            v-model="form.hValue1"
            controls-position="right"
            :min="minhealth1"
            :max="1000"
            @change="value1Change"
          ></el-input-number>
          -
          <el-input-number
            style="width: 100px"
            v-model="form.hValue2"
            controls-position="right"
            :min="minhealth2"
            :max="1000"
            @change="value2Change"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="健康风险等级">
          <el-select
            v-model="form.hValueLevelTemp"
            clearable
            multiple
            placeholder="请选择"
            @change="jfkf"
          >
            <el-option
              v-for="item in hValueLevelList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="高风险疾病">
          <el-select
            v-model="form.highRiskDiseasesTemp"
            clearable
            filterable
            multiple
            placeholder="请选择"
          >
            <el-option
              v-for="item in highRiskDiseasesList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="可控风险">
          <el-select
            v-model="form.riskFactorControllableTemp"
            clearable
            filterable
            multiple
            placeholder="请输入关键词"
          >
            <el-option
              v-for="item in riskFactorControllableList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>

          <!-- <el-select
            @change="riskFactorControllableMethod"
            @focus="riskFactorControllableMethod"
            v-model="form.riskFactorControllable"
            filterable
            remote
            placeholder="请输入关键词"
            :remote-method="riskFactorControllableMethod"
            :loading="loading"
          >
            <el-option
              v-for="item in riskFactorControllableList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select> -->
        </el-form-item>
        <el-form-item label="日期">
          <el-date-picker
            v-model="form.date"
            type="daterange"
            range-separator="至"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-button
          size="mini"
          class="search-btn"
          v-auth="'sa_user_page'"
          type="primary"
          @click="getData(true)"
          >查询</el-button
        >
        <el-button
          class="search-btn"
          v-auth="'sa_item_page'"
          type="primary"
          @click="() => ($root.showPage = false)"
          >重置</el-button
        >
      </el-form>
    </el-row>
    <div class="cont-x" ref="tableBox">
      <div class="table-x">
        <el-table
          v-loading="loading"
          :data="tableData"
          :height="tableHeight"
          border
          class="mb20"
        >
          <el-table-column align="center" label="序号" width="100">
            <template slot-scope="scope">
              {{ (page.pageNo - 1) * page.pageSize + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="userId" align="center" label="用户ID">
          </el-table-column>
          <el-table-column prop="name" align="center" label="用户姓名">
          </el-table-column>
          <el-table-column prop="mobile" align="center" label="手机号">
          </el-table-column>
          <el-table-column align="center" label="证件类型">
            <template slot-scope="scoped">
              <span v-if="scoped.row.cardNo">{{
                cardType[scoped.row.cardType] || ""
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="cardNo" align="center" label="证件号码">
          </el-table-column>
          <el-table-column align="center" label="来源">
            <template slot-scope="scope">
              {{ scope.row.source | optionsFilter(userSourceList) }}
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            min-width="120px"
            label="数据更新时间"
          >
            <template slot-scope="scope">
              {{ scope.row.updateTime }}
            </template>
          </el-table-column>
          <el-table-column
            prop="hValue"
            align="center"
            label="健康值"
          ></el-table-column>
          <el-table-column
            prop="hValueLevel"
            align="center"
            label="健康风险等级"
          ></el-table-column>
          <el-table-column
            prop="highRiskDiseasesCount"
            align="center"
            label="高风险疾病"
          ></el-table-column>
          <el-table-column
            prop="riskFactorControllableCount"
            align="center"
            label="可控风险因子"
          ></el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            width="240"
            align="center"
          >
            <template slot-scope="scope">
              <el-button-group>
                <el-button
                  v-auth="'sa_user_view'"
                  size="middle"
                  class="mb10"
                  type="text"
                  @click="toDetail(scope.row)"
                  >查看</el-button
                >
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="pagenation-x">
      <div class="pagination mb20">
        <el-pagination
          @current-change="getData"
          :current-page.sync="page.pageNo"
          @size-change="getData"
          :page-sizes="[10, 50, 100]"
          :page-size.sync="page.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="page.total"
          background
        >
        </el-pagination>
      </div>
    </div>
  </el-container>
</template>

<script>
const sexIndex = {
  0: "男",
  1: "女",
  2: "未知",
};
import { mapGetters } from "vuex";
import { userSourceList, cardType } from "@/assets/js/options";

// import { controllable } from "../../../config/api.js";

export default {
  name: "userManagement",
  data() {
    return {
      // 搜索条件 TODO
      xiangmList: [],
      hValueLevelList: [
        { label: "无", value: "无" },
        { label: "极差", value: "极差" },
        { label: "很差", value: "很差" },
        { label: "较差", value: "较差" },
        { label: "一般", value: "一般" },
        { label: "较好", value: "较好" },
        { label: "很好", value: "很好" },
        { label: "非常好", value: "非常好" },
      ],
      highRiskDiseasesList: [
        { label: "肺癌", value: "肺癌" },
        { label: "胃癌", value: "胃癌" },
        { label: "肝癌", value: "肝癌" },
        { label: "食管癌", value: "食管癌" },
        { label: "结直肠癌", value: "结直肠癌" },
        { label: "乳腺癌", value: "乳腺癌" },
        { label: "子宫颈癌", value: "子宫颈癌" },
        { label: "鼻咽癌", value: "鼻咽癌" },
        { label: "膀胱癌", value: "膀胱癌" },
        { label: "糖尿病", value: "糖尿病" },
        { label: "缺血性心血管病", value: "缺血性心血管病" },
        { label: "高血压", value: "高血压" },
      ],
      riskFactorControllableList: [],
      /**
       * 表单相关
       */
      // 查询条件
      form: {}, // form 信息
      /**
       * 表格相关
       */
      loading: true,
      // 页数相关信息
      page: {
        pageSize: 10,
        pageNo: 1,
        total: 0,
      },
      tableHeight: 0,
      tableData: [], // 表格数据
      sexIndex, // 性别索引列表
      userSourceList, // 用户来源列表
      cardType, // 证件类型
      rlist: [], //可控风险
      minhealth1: 0,
      minhealth2: 0,
    };
  },
  computed: {
    ...mapGetters(["authMap"]),
  },
  created() {
    // 面包导航
    this.$root.breadList = [
      { name: "用户管理", link: "" },
      { name: "用户档案", link: "" },
    ];
  },
  mounted() {
    if (!this.authMap["sa_user_page"]) {
      this.loading = false;
      this.$message.error("抱歉，您暂无权限");
      return;
    }
    this.$nextTick(() => {
      this.listenWindow();
      this.getData();
    });
    this.controllable();
  },
  filters: {
    optionsFilter(text, list) {
      let data = list.find((e) => Number(text) == e.value);
      if (data) return data.label;
      else return "";
    },
  },
  methods: {
    jfkf(val) {
      console.log(val);
    },
    value1Change(val) {
      console.log(val);
      this.minhealth2 = val;
      if (this.form.hValue1 >= this.form.hValue2) {
        this.form.hValue2 = val;
      }
    },
    value2Change(val) {
      console.log(val);
      this.this.minhealth1 = val;
    },
    /**
     * 可控风险
     */
    async controllable() {
      let res = await this.axios.get(this.getApiUrl("controllable"), {});
      this.rlist = res.data.map((item) => {
        return { value: `${item}`, label: `${item}` };
      });
      console.log(this.rlist);
      this.riskFactorControllableList = this.rlist;
    },
    // remoteMethod(query) {
    //   if (query !== "") {
    //     setTimeout(() => {
    //       this.riskFactorControllableList = this.rlist.filter((item) => {
    //         return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
    //       });
    //     }, 200);
    //   } else {
    //     this.riskFactorControllableList = [];
    //   }
    // },
    //窗口改变，重新取得高度
    listenWindow() {
      this.tableHeight = this.$refs.tableBox.offsetHeight;
      window.addEventListener("resize", () => {
        clearTimeout(this.resizeFlag);
        this.resizeFlag = setTimeout(() => {
          try {
            this.tableHeight = this.$refs.tableBox.offsetHeight;
          } catch (error) {}
        }, 300);
      });
    },
    /**
     * 查看
     */
    toDetail(item) {
      // let name = ["sa_user_order_page","sa_user_abnormal_page"].find(item => this.authMap[item])
      // name = {
      //     "sa_user_order_page": "detailExamination",
      //     "sa_user_abnormal_page": "detailAbnormal"
      // }[name]
      // if (name) {
      // let routeUrl = this.$router.resolve({
      //     name: "detailAbnormal",
      //     query: {
      //         userId: item.userId,
      //     },
      // });
      // window.open(routeUrl.href, "_blank");
      // } else {
      //     this.$message.error('抱歉，您暂无权限')
      // }
      if (this.$store.state.healthDocUser) {
        this.$store.state.healthDocUser.detailUserItem.sex =
          this.sexIndex[item.gender] || "未知";
        this.$store.state.healthDocUser.userId = item.userId;
      }
      sessionStorage.setItem(
        "health-user",
        JSON.stringify(this.$store.state.healthDocUser)
      );
      // 0 男 1 女
      localStorage.setItem("user-sex", item.gender);
      this.$router.push({
        path: "/user/health-info",
      });
    },
    /**
     * 重置表单
     */
    resetForm() {
      this.form = {};
      this.$forceUpdate();
    },
    /**
     * 获取数据
     */
    async getData(resetPage) {
      console.log(this.form);
      if (resetPage === true) this.page.pageNo = 1;
      this.loading = true;
      if (this.form.date && this.form.date.length > 0) {
        this.form.updateTimeBegin = this.form.date[0] + " 00:00:00";
        this.form.updateTimeEnd = this.form.date[1] + " 23:59:59";
      }
      this.form.maxHValue = this.form.hValue2;
      this.form.minHValue = this.form.hValue1;
      if (this.form.highRiskDiseasesTemp.length > 0) {
        this.form.highRiskDiseases = this.form.highRiskDiseasesTemp.join(",");
      } else {
        this.form.highRiskDiseases = "";
      }
      if (this.form.riskFactorControllableTemp.length > 0) {
        this.form.riskFactorControllable =
          this.form.riskFactorControllableTemp.join(",");
      } else {
        this.form.riskFactorControllable = "";
      }
      if (this.form.hValueLevelTemp.length > 0) {
        this.form.hValueLevel = this.form.hValueLevelTemp.join(",");
      } else {
        this.form.hValueLevel = "";
      }
      let params = Object.assign({}, this.page, this.form);
      let res = await this.axios.get(this.getApiUrl("userPage"), {
        params,
      });
      this.tableData = res?.data?.data || [];
      this.page.total = res?.data?.total || 0;
      this.loading = false;
    },
  },
};
</script>
<style type="text/scss" lang="scss" scoped>
.userManagement-box {
  .search-x {
    // min-height: 120px;
    flex-shrink: 0;
  }
  .cont-x {
    flex: 1;
    flex-shrink: 0;
  }
}
</style>
